module.exports = __webpack_public_path__ + "img/icon-misc.ae8e6d9c.svg";